export default "__VITE_ASSET__DIETvicb__"